const { getAxiosInstance } = require('./connection');

async function downloadFile(url, { headers = {}, filename = 'download.bin', mime = 'application/octet-stream' } = {}) {
    const response = await getAxiosInstance({
        method: 'get',
        url,
        headers,
        responseType: 'blob', // 👈 important
        // withCredentials: true, // 👈 if you also need cookies
    });

    // Try to extract filename from Content-Disposition
    let suggestedName = filename;
    const disposition = response.headers['content-disposition'];
    if (disposition) {
        const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(disposition);
        const raw = decodeURIComponent((match && (match[1] || match[2] || '')).trim());
        if (raw) suggestedName = raw;
    }

    const blob = new Blob([response.data], { type: mime });
    const urlObj = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = urlObj;
    a.download = suggestedName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    // cleanup
    setTimeout(() => URL.revokeObjectURL(urlObj), 1000);
}

module.exports = downloadFile;
